/* eslint-disable camelcase */
import projectApis from 'api/project'
import { createApiHandler } from 'helpers/apiHandler'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'
import { message, notification } from 'antd'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { myProjectActions } from 'redux/MyProject/myProject.actions'
import { projectDetailActions } from 'redux/ProjectDetail/project-detail.actions'
import { NextRouter } from 'next/router'

const types = {
  CREATE_PROJECT: createActionsSet.api('project.create-project'),
  UPDATE_PROJECT: createActionsSet.api('project.update-project'),
  VERIFY_EMAIL: createActionsSet.api('project.Verify-email'),
  SET_IS_UPDATE_SUCCESS: 'project-detail.set-is-update-success',
}
const createProject =
  ({
    email,
    tokenAddress,
    chainId,
    ownerAddress,
  }: {
    email: string
    tokenAddress: string
    chainId: number
    ownerAddress: string
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({ type: types.CREATE_PROJECT.REQUEST })
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(projectApis.createProject({ email, tokenAddress, chainId, ownerAddress }))

      dispatch({ type: types.CREATE_PROJECT.SUCCESS, payload: response })
      notification.success({
        message: 'Create project successfully!',
        description:
          'A verification email has been sent to your email address. Please check your inbox and follow the instructions to verify your project.',
      })
    } catch (e: any) {
      notification.error({
        message: 'An error occurred!',
        description: e.response?.data?.message || '',
      })
      dispatch({ type: types.CREATE_PROJECT.FAILED, payload: e })
      dispatch(appLoadingFeatureActions.finish())
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const verifyEmail =
  ({ token, router }: { token: string; router: NextRouter }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({ type: types.VERIFY_EMAIL.REQUEST })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response: any = await handleApi(projectApis.verifyEmail({ token }))
      if (response.error) {
        router.push('/create-project')
      } else {
        dispatch({ type: types.VERIFY_EMAIL.SUCCESS, payload: response.data })
      }
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.VERIFY_EMAIL.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const updateProject =
  ({
    id,
    title,
    description,
    youtube_presentation,
    social,
    website,
    audit,
    logo,
    banner,
    router,
  }: {
    id: string
    title: string
    description: string
    youtube_presentation: string
    social: Array<{ channel: string; url: string }>
    website: string
    audit: Array<{ provider: string; url: string }>
    logo: string
    banner: string
    router?: NextRouter
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({ type: types.UPDATE_PROJECT.REQUEST })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createApiHandler(dispatch, getState)
      const response = await handleApi(
        projectApis.updateProject({
          id,
          title,
          description,
          youtube_presentation,
          social,
          website,
          audit,
          logo,
          banner,
        }),
      )
      dispatch({ type: types.UPDATE_PROJECT.SUCCESS, payload: response })

      dispatch(projectDetailActions.getProjectDetail({ id }))
      notification.success({ message: 'Success', description: 'Update successfully!' })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      notification.error({ message: 'Error', description: 'Update failed!' })
      dispatch({ type: types.UPDATE_PROJECT.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
export const projectActions = {
  types,
  createProject,
  verifyEmail,
  updateProject,
}
